import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';

export default function Comp() {
    const { t } = useLang('theProduct.GoodsA');

    return (
        <>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} />
            <EcoSpaceSmall />
            <img src="https://websiteoss.ecoflow.com/upload/image/1741257568717/Frame%201612690129.jpg" className="demo-img-full" />
        </>
    );
}
